import * as React from "react";
import { useCallback, useContext } from "react";
import { useFormikContext } from "formik";
import { FormikHelpers } from "formik/dist/types";

import { InnerFormContext } from "../../controls/innerFormContext";
import { useToFormOnEmpty } from "../../helpers";
import { ValueRecord } from "../../types";

export const ConfirmationWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const formContext = useContext(InnerFormContext);
  const formikHelpers = useFormikContext();
  const handleSubmit = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if ((e.target as HTMLDivElement).getAttribute("type") === "submit") {
        formContext?.submitData(formikHelpers as FormikHelpers<ValueRecord>);
      }
    },
    [formContext, formikHelpers]
  );
  useToFormOnEmpty(formContext?.formData);
  return <div onClick={handleSubmit}>{children}</div>;
};
